import React, { useState } from "react";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import ImageGridInstagram from "../components/ImageGridInstagram";
import ImageListViewInstagram from "../components/ImageListViewInstagram";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const photos = [
  {
    src: "/images/marija_2.jpeg",
    description: "Work less and travel more 😉",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_17.jpeg",
    description: "I had to take this one 😊📷",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_18.jpeg",
    description: "This might be my default look 👀",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_3.jpeg",
    description: "Making my way downtown ✨",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_4.jpeg",
    description: "🌞😌",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_5.jpeg",
    description: "🌊 #happyplace",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_6.jpeg",
    description: "Jedna spontana pred put #roadtrip",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_7.jpeg",
    description: "Working from home #mood",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_8.jpeg",
    description: "Wondering and wandering 😏",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_9.jpeg",
    description: "🐶: Hoću i ja #selfie! 😂",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_10.jpeg",
    description: "My inner child right now be like... 🙃",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_11.jpeg",
    description: "🌻✈️😃",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_12.jpeg",
    description: "In the eye of the storm 👁️",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_13.jpeg",
    description: "I'm just a 🌻 in the 🌎",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_14.jpeg",
    description: "HR mode: ON 👓☕☀️",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_15.jpeg",
    description: "🪷",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_16.jpeg",
    description: "#wildbeach #vibes 🏖️",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
];
export default function InstagramDesktopMarija({
  username = "marija_s",
  bio = "Life is supposed to be fun! content creator",
  avatarUrl = "/images/marija_1.png",
  posts = 730,
  followers = "8k",
  following = 671,
}) {
  const [activeTab, setActiveTab] = useState("grid");
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const navigate = useNavigate();

  return (
    <div className="instagram-page">
      <div className="instagram-right">
        <div className="tab-icon-face">
          <AccountCircleIcon
            className={`tab-icon active`}
            fontSize="large"
            style={{ fontSize: "60px" }}
            onClick={() => handleTabClick("grid")}
          />
        </div>
        <div className="tab-icon-instagram">
          <GridOnOutlinedIcon
            className={`tab-icon ${activeTab === "grid" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("grid")}
          />
        </div>
        <div className="tab-icon-instagram">
          <ViewListOutlinedIcon
            className={`tab-icon ${activeTab === "list" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("list")}
          />
        </div>
        <div className="tab-icon-instagram">
          <SearchOutlinedIcon
            className={`tab-icon ${activeTab === "search" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("search")}
          />
        </div>
        <div className="tab-icon-instagram">
          <BookmarkBorderOutlinedIcon
            className={`tab-icon ${activeTab === "saved" ? "active" : ""}`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => handleTabClick("saved")}
          />
        </div>
      </div>
      <div className="instagram-left">
        <div className="instagram-left-header">
          <div className="search-bar">
            <SearchOutlinedIcon
              className={`nav-icon-instagram`}
              fontSize="large"
              style={{ fontSize: "35px" }}
            />
            <input
              type="text"
              value=""
              className="search-input"
              placeholder="Search..."
            />
          </div>
          <HomeOutlinedIcon
            className={`nav-icon-instagram active`}
            fontSize="large"
            style={{ fontSize: "45px" }}
          />
          <SmartDisplayOutlinedIcon
            className={`nav-icon-instagram`}
            fontSize="large"
            style={{ fontSize: "45px" }}
            onClick={() => navigate("/notifikacije")}
          />
          <button className="add-photo-btn">
            <FaPlus className="add-photo-icon" />
            Add photo
          </button>
        </div>

        <div className="instagram-top">
          <div className="instagram-avatar-ring">
            <img
              className="instagram-avatar"
              src={avatarUrl}
              alt={`${username} avatar`}
            />
          </div>

          <div className="instagram-user">
            <div className="instagram-row">
              <div className="instagram-username">{username}</div>
            </div>
            <div className="instagram-bio">{bio}</div>
          </div>
        </div>
        <div className="instagram-actions">
          <button className="instagram-btn-following">Following</button>
          <button className="instagram-btn-message">Message</button>
          <button className="instagram-btn-icon" aria-label="Add">
            <span className="instagram-plus">＋</span>
          </button>
        </div>
        <div className="instagram-stats">
          <div className="instagram-stat">
            <div className="instagram-num">{posts}</div>
            <div className="instagram-label">posts</div>
          </div>
          <div className="instagram-stat">
            <div className="instagram-num">{followers}</div>
            <div className="instagram-label">followers</div>
          </div>
          <div className="instagram-stat">
            <div className="instagram-num">{following}</div>
            <div className="instagram-label">following</div>
          </div>
        </div>
        <div className="instagram-profile-tabs">
          <GridOnOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "grid" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("grid")}
          />

          <ViewListOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "list" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("list")}
          />

          <SearchOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "search" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("search")}
          />

          <BookmarkBorderOutlinedIcon
            className={`instagram-tab-icon ${
              activeTab === "saved" ? "active" : ""
            }`}
            fontSize="large"
            onClick={() => handleTabClick("saved")}
          />
        </div>
        {activeTab === "grid" ? (
          <ImageGridInstagram images={photos} />
        ) : (
          <ImageListViewInstagram images={photos} />
        )}
      </div>
    </div>
  );
}
